import * as RadixTooltip from "@radix-ui/react-tooltip";
import { styled } from "@pigment-css/react";
import { MetricCard } from "../../ui";
import { Divider } from "../../../primitives";
import { useLocale, useTranslations } from "@acto/web-common/locales";
import { useCurrencyContext } from "@acto/taskpane/core/contexts/TenantSettingsContext";
import { formatCurrency } from "@acto/taskpane/core/utils/formatters";
import { formatProfitWithMargin } from "../../../../utils/formatters";

interface CustomerMetricsSectionProps {
  revenue: {
    value: number;
    percentageChange: number | null;
    changeTooltip?: string;
  };
  margin: {
    value: number;
  };
  profit: {
    value: number;
    percentageChange: number | null;
    changeTooltip?: string;
  };
}

const OuterWrapper = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.managementView.spacing[16],
}));

export const CustomerMetricsSection = ({ revenue, margin, profit }: CustomerMetricsSectionProps) => {
  const t = useTranslations();
  const { locale } = useLocale();
  const currency = useCurrencyContext();

  return (
    <>
      <RadixTooltip.Provider delayDuration={200}>
        <OuterWrapper>
          <MetricCard
            label={t("managementView.customerDetails.revenue")}
            value={formatCurrency(revenue.value, locale, currency)}
            change={revenue.percentageChange}
            changeTooltip={revenue.changeTooltip}
          />
          <MetricCard
            label={t("managementView.customerDetails.margin")}
            value={formatProfitWithMargin(profit.value, margin.value, locale, currency)}
            change={profit.percentageChange}
            changeTooltip={profit.changeTooltip}
          />
        </OuterWrapper>
      </RadixTooltip.Provider>
      <Divider />
    </>
  );
};
